angular.module('env.custom.customCss', [])

    .directive('customCss', function ($log, context, customResourceResolver) {

        return {
            restrict: 'E',
            controller: function ($scope, $element) {

                var oldCustomCssUrl = null; // old value of resolved css url

                var recompile = function () {

                    var customAliasExpression = $element.attr("name");
                    var customAlias;
                    try {
                        customAlias = $scope.$eval(customAliasExpression);
                    } catch (e) {
                        $log.error("'custom-css' directive can't evaluate expression from 'name' attribute.", e);
                        return;
                    }

                    customResourceResolver.resolveStyle(customAlias, null).then(function (customCssUrl) {
                        if (customCssUrl == oldCustomCssUrl) {
                            return;
                        }

                        oldCustomCssUrl = customCssUrl;

                        $element.empty();
                        if (angular.isDefined(customCssUrl) && angular.isString(customCssUrl)) {
                            $element.append("<link rel='stylesheet' type='text/css' href='" + customCssUrl + "'>");
                        } else {
                            $log.warn("Can't find custom css for name '" + customAlias + "'");
                        }
                    });
                };

                $scope.$watch(
                    function () {
                        return $element.attr("name");
                    },
                    function (newVal, oldVal) {
                        if (newVal != oldVal) {
                            recompile();
                        }
                    }
                );

                //Subscribe to the context changed event to recompile directive and redraw the content if any
                //in order to reflect the template change according to the new context (user or any other customisation data)
                if (context) {
                    context.events.on('changed', function () {
                        recompile();
                    });
                }

                recompile();
            }
        };
    })

;